var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 60,
    fill: "none",
    preserveAspectRatio: "xMinYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.94 13.668v24.46a8 8 0 01-8 8H19.152c-.1-1.02-.15-2.055-.15-3.101 0-17.397 14.103-31.5 31.5-31.5 4.034 0 7.892.758 11.438 2.14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    fillRule: "evenodd",
    d: "M42.463 25.216a1.02 1.02 0 011.471 0l4.384 4.513c.63.648.63 1.698 0 2.347l-4.383 4.512a1.02 1.02 0 01-1.472 0 1.094 1.094 0 010-1.514l3.004-3.093H38.12c-.578 0-1.047-.483-1.047-1.079s.469-1.079 1.047-1.079h7.346l-3.004-3.092a1.094 1.094 0 010-1.515z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.7e13396e3a4ad3ff36d82accf196dfce.svg";
export { ForwardRef as ReactComponent };